import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Ticket from "../components/Ticket";
import Map from "../components/Map";
import moment from "moment";
import React from "react";

export default function Index() {
  const tickets = useSelector((state) => state.tickets);

  const [searchParams] = useSearchParams();
  const showFutureDates = searchParams.get("future");

  return (
    <div className="relative overflow-hidden">
      <main className="container px-4 py-12 space-y-12">
        <section className="grid gap-6 grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
          <header className="intro max-w-lg mx-auto lg:row-span-2">
            <div className="bg-white h-full w-full bg-opacity-30 p-10 flex flex-col text-rose-400">
              <h1 className="text-4xl mb-4">
                A collection of tickets from gigs I've been to throughout the
                years.
              </h1>

              <p className="text-xl mt-auto">
                Built with React and Tailwind ❤️
              </p>
            </div>
          </header>

          {tickets
            .slice()
            .filter((ticket) => {
              if (showFutureDates) {
                return true;
              }

              // Reformat the date because JS is a steaming pile of shit
              const [day, month, year] = ticket.date.split("/");

              // Filter out future gigs
              return new Date([month, day, year].join("/")) < new Date();
            })
            .sort((a, b) => {
              return (
                moment(b.date, "DD/MM/YYYY").toDate() -
                moment(a.date, "DD/MM/YYYY").toDate()
              );
            })
            .map((ticket, i) => (
              <React.Fragment key={ticket.date}>
                {i === 16 && (
                  <div className="lg:col-span-2 lg:row-span-2">
                    <div className="frame">
                      <div className="mat">
                        <div className="art">
                          <Map />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <Ticket ticket={ticket} />
              </React.Fragment>
            ))}
        </section>
      </main>

      <footer>
        <img src="/img/floor.jpg" alt="" />
      </footer>
    </div>
  );
}
